import { render, staticRenderFns } from "./NumberComponent.vue?vue&type=template&id=d295be4c&scoped=true"
import script from "./NumberComponent.vue?vue&type=script&lang=js"
export * from "./NumberComponent.vue?vue&type=script&lang=js"
import style0 from "./NumberComponent.vue?vue&type=style&index=0&id=d295be4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d295be4c",
  null
  
)

export default component.exports